import {LocalStorageServiceConfig} from "@/interfaces/local-storage.interface";

class Service {

  toggleFavoriteFilm(id: number) {
    let rhizomeFavorite = (window.localStorage['rhizomeFavorites']) ? JSON.parse(window.localStorage['rhizomeFavorites']) : [];

    if (rhizomeFavorite.includes(Number(id))) {
      rhizomeFavorite = rhizomeFavorite.filter( (value) => value !== Number(id));
      window.localStorage['rhizomeFavorites'] = JSON.stringify(rhizomeFavorite);
    }
    else {
      rhizomeFavorite.push(Number(id));
      window.localStorage['rhizomeFavorites'] = JSON.stringify(rhizomeFavorite);
    }
  }

  pushHistory(item: LocalStorageServiceConfig.IHistoryItem) {
    let rhizomeHistory = (window.localStorage['rhizomeHistory']) ? JSON.parse(window.localStorage['rhizomeHistory']) : [];

    if ((item.type === LocalStorageServiceConfig.HistoryItemTypes.FILM && rhizomeHistory[0]?.id !== item.id) ||
        (item.type === LocalStorageServiceConfig.HistoryItemTypes.KEYWORD && rhizomeHistory[0]?.keyword?.entity_id !== item?.keyword?.entity_id)) {

      rhizomeHistory.unshift(item);
      rhizomeHistory = rhizomeHistory.slice(0, 10);
      window.localStorage['rhizomeHistory'] = JSON.stringify(rhizomeHistory);
    }
  }

  getFavoriteList(): number[] {
    return (window.localStorage['rhizomeFavorites']) ? JSON.parse(window.localStorage['rhizomeFavorites']) : [];
  }

  getHistoryList(): LocalStorageServiceConfig.IHistoryItem[] {
    return (window.localStorage['rhizomeHistory']) ? JSON.parse(window.localStorage['rhizomeHistory']) : [];
  }
}

export const localStorageService = new Service();
